import React from "react";
import Counter from "./Counter";

//Import Background Banner
import backgroundBanner from "../../../assets/images/Believe-banner.png";

const BelieveInNumbers = () => {
  return (
    <div
      style={{ backgroundImage: `url(${backgroundBanner})` }}
      className="bg-cover bg-no-repeat bg-center flex justify-center items-center flex-col my-12 lg:my-20"
    >
      {/* Section Heading */}
      <div className="my-8 md:my-14 text-center" data-aos="fade-up">
        <h1 className="text-[#252525] font-bold text-2xl md:text-4xl xl:text-5xl oxygen">
          “ We Believe in Numbers “
        </h1>
        <p className="text-[#868686] text-sm md:text-base lg:text-lg xl:text-xl px-6 md:px-12 lg:px-36 my-4 md:my-8">
          "We Believe in Numbers" emphasizes a commitment to data, metrics, and
          measurable outcomes. It reflects a focus on evidence-based
          decision-making, precision, and the power of numbers to drive success
          and understanding.
        </p>
      </div>

      {/* Numbers */}

      <Counter />
    </div>
  );
};

export default BelieveInNumbers;
